import { render } from "./MovieItem.vue?vue&type=template&id=5e398100&scoped=true"
import script from "./MovieItem.vue?vue&type=script&lang=js"
export * from "./MovieItem.vue?vue&type=script&lang=js"

import "./MovieItem.vue?vue&type=style&index=0&id=5e398100&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_ba160c7cc2f29ece52adbe34bb7fc3d0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e398100"]])

export default __exports__